import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable, map, zip} from 'rxjs';
import {CommonBlobStorageService} from 'src/app/shared/services/blob-storage/common-blob-storage.service';
import {SpinnerOverlayService} from 'src/app/shared/services/spinner-overlay/spinner-overlay.service';

@Injectable({
  providedIn: 'root',
})
export class ClaimsGuard {
  private claimsBlobStorageService = inject(CommonBlobStorageService);
  private spinnerOverlayService = inject(SpinnerOverlayService);
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.spinnerOverlayService.performWithSpinner(zip(
      this.claimsBlobStorageService.loadBlobStorageConfiguration()
    ).pipe(
      map(() => {
        return true;
      })
    ));
  }
}
